import TextField from "@mui/material/TextField";
import type { TextFieldProps } from "@mui/material/TextField";
import type {
  ChangeEvent,
  HTMLInputTypeAttribute,
  KeyboardEventHandler,
  MouseEventHandler,
} from "react";

export interface InputBoxProps {
  index: number;
  value?: unknown;
  isFocused?: boolean;
  setValue: (index: number, value: string | undefined) => void;
  variant?: TextFieldProps["variant"];
  type?: HTMLInputTypeAttribute;
  onKeyDown?: KeyboardEventHandler<HTMLDivElement>;
  handleBlur?: () => void;
  onMouseDown?: MouseEventHandler<HTMLDivElement>;
  error?: boolean;
}

export function InputBox({
  index,
  value,
  isFocused,
  setValue,
  variant,
  type,
  onKeyDown,
  handleBlur,
  onMouseDown,
  error,
}: InputBoxProps) {
  const handleChange = ({ target }: ChangeEvent<HTMLInputElement>) => {
    const currentVal = target.value ? target.value.at(target.value.length - 1) : "";
    setValue(index, currentVal);
  };

  return (
    <TextField
      type={type}
      size="medium"
      value={value}
      variant={variant}
      error={error}
      sx={{
        "& .MuiFilledInput-root": {
          border: error ? "1px solid #FF0000" : "1px solid #E7E7E7",
        },
        color: "red",
        width: "47px",
        fontWeight: "bold",
        borderRadius: "6px",
      }}
      autoFocus={isFocused}
      onChange={handleChange}
      onKeyDown={onKeyDown}
      onBlur={handleBlur}
      onMouseDown={onMouseDown}
      InputProps={{
        inputProps: {
          style: { textAlign: "center" },
        },
      }}
    />
  );
}
